"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SonorasShieldAbilityHandler = exports.SonorasShieldActorAbilityFactory = exports.SonorasShieldAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
class SonorasShieldAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SonorasShield;
        this.__typeName = "SonorasShield";
    }
}
exports.SonorasShieldAbilityArgs = SonorasShieldAbilityArgs;
let SonorasShieldActorAbilityFactory = class SonorasShieldActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SonorasShield", "OneAllies", 3);
    }
};
SonorasShieldActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SonorasShield")
], SonorasShieldActorAbilityFactory);
exports.SonorasShieldActorAbilityFactory = SonorasShieldActorAbilityFactory;
let SonorasShieldAbilityHandler = class SonorasShieldAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAlly] = ability.args.target.actorIds;
        const armorIncrease = Math.round(0.25 * container.getLevel(ability.invokerId));
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "casting",
            onAnimated: sequence => {
                container.applyBuff({
                    creatorId: ability.invokerId,
                    targetId: selectedAlly,
                    duration: Duration_1.Duration.Turns(3),
                    effect: new core_1.LinkedEffectsEffectArgs([
                    // TODO: rework.
                    ], false),
                    sequence
                });
            }
        });
    }
};
SonorasShieldAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SonorasShield)
], SonorasShieldAbilityHandler);
exports.SonorasShieldAbilityHandler = SonorasShieldAbilityHandler;
